import React from 'react';
import { makeStyles } from '@material-ui/core';
import { COLOR_BLACK, COLOR_WHITE, COLOR_STEAK_SAUCE } from '../../../../colors';
import {
    TypeIcon,
} from './Icons';

const TYPE_LABELS = {
    singular: {
        park: 'Park',
        'dog-park': 'Dog Park',
        'golf-course': 'Golf Course',
        hiking: 'Hiking',
        lake: 'Lake',
        beach: 'Beach',
    },

    plural: {
        park: 'Parks',
        'dog-park': 'Dog Parks',
        'golf-course': 'Golf Courses',
        hiking: 'Hiking',
        lake: 'Lakes',
        beach: 'Beaches',
    },
};


const useStyles = makeStyles((theme)=> ({
    outdoorInfographicWrap: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        boxSizing: 'border-box',
        padding: '20px 24px 64px',
    },
    heading: {
        fontSize: '34px',
        lineHeight: '48px',
        fontWeight: 900,
        textAlign: 'center',
    },
    subheading: {
        position: 'relative',
        fontSize: 20,
        lineHeight: '28px',
        fontWeight: 900,
        backgroundColor: COLOR_BLACK,
        color: COLOR_WHITE,
        margin: '12px auto 0',
        padding: '10px 0',
        zIndex: 1,

        '&::before': {
            position: 'absolute',
            left: -25,
            top: 0,
            content: "''",
            height: 48,
            width: 48,
            backgroundColor: COLOR_BLACK,
            borderTopLeftRadius: 52,
            borderBottomLeftRadius: 52,
            zIndex: -1,
        },

        '&::after': {
            position: 'absolute',
            right: -25,
            top: 0,
            content: "''",
            height: 48,
            width: 48,
            backgroundColor: COLOR_BLACK,
            borderTopRightRadius: 52,
            borderBottomRightRadius: 52,
            zIndex: -1,
        },
    },
    outdoorsList: {
        marginTop: 24,
    },
    outdoorsListItem: {
        display: 'flex',
        flex: 1,
        justifyContent: 'start center',
        minHeight: 80,
        marginBottom: 16,
        '&:last-of-type': {
            marginBottom: 0,
        }
    },
    outdoorsListItemColumn: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    iconDisc: {
        display: 'flex',
        minWidth: 64,
        height: 64,
        flexDirection: 'column',
        border: `4px solid ${COLOR_BLACK}`,
        justifyContent: 'center',
        marginRight: 24,
        borderRadius: '50%',
    },
    iconWrap: {
        paddingTop: '2px',
        textAlign: 'center',
    },
    outdoorStatus: {
        color: COLOR_STEAK_SAUCE,
        fontSize: 16,
        lineHeight: '22px',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        fontWeight: 700,
        marginBottom: 2,
    },
    outdoorCount: {
        fontSize: 24,
        lineHeight: '32px',
        fontWeight: 900,
        letterSpacing: 'initial',
    },
    outdoorFeatureInfo: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '0.5px',
    },
}));

export function OutdoorsInfographic({
    outdoors,
}) {
    const classes = useStyles();
    return (
        <div className={classes.outdoorInfographicWrap}>
            <div className={classes.heading}>Outdoor activities</div>
            <div className={classes.subheading}>
                <div>Within 10 miles</div>
            </div>

            {outdoors?.length > 0 && (<div className={classes.outdoorsList}>
                {outdoors.filter(Boolean).map((outdoor)=> (
                    <div className={classes.outdoorsListItem}
                        key={`${outdoor.name} ${outdoor.range}`}
                    >
                        <div className={classes.outdoorsListItemColumn}>
                            <div className={classes.iconDisc}>
                                <div className={classes.iconWrap}>
                                    <TypeIcon type={outdoor.type} />
                                </div>
                            </div>
                        </div>

                        <div className={`${classes.outdoorsListItemColumn} ${classes.outdoorFeatureInfo}`}>
                            {outdoor.count && (
                                <div className={classes.outdoorCount}>{outdoor.count} {
                                    TYPE_LABELS[outdoor.count === 1 ? 'singular' : 'plural'][outdoor.type]
                                }</div>
                            )}
                            {outdoor.name && (<div><strong>Popular:</strong> {outdoor.name}</div>)}
                            {outdoor.distance && (<div>Distance: {outdoor.distance} mile{outdoor.distance === '1.0' || outdoor.distance === '1' ? '' : 's'}</div>)}
                        </div>
                    </div>
                ))}
            </div>)}
        </div>
    );
}
